






























import 'vue-awesome/icons/search'
TransactionsFilter = require('components/inside/pages/transactions/filter.coffee')

export default
  name: 'reports_period'
  components:
    period_totals:          require('./period_totals.vue').default
    period_by_months_chart: require('./period_by_months_chart.vue').default
    period_categories:      require('./period_categories.vue').default
    period_accounts:        require('./period_accounts.vue').default
    range_changer:          require('./period_range_changer.vue').default
    categories_stats:       require('./../transactions/categories_stats.vue').default
  props: ['range']
  data: ->
    ready_to_draw: false
    selected_range: null
    filter_visible: false
    accounts:
      included: []
    categories:
      included: []
      excluded: []
  computed:
    filter_hideable: ->
      _.sumBy([
        @categories.included, @categories.excluded,
        @accounts.included, @accounts.excluded
      ], 'length') == 0
    all_trs: ->
      return [] if @selected_range == null
      res = @$store.getters.transactions_entered.filter (tr) =>
        return false if tr.date < @selected_range.start || tr.date > @selected_range.end
        return true
      if @categories.included.length
        res = TransactionsFilter res, { categories_included: @categories.included }
      if @categories.excluded.length
        res = TransactionsFilter res, { categories_excluded: @categories.excluded }
      if @accounts.included.length
        res = TransactionsFilter res, { account_id: @accounts.included }
      requestIdleCallback -> Vue.observable(res) # Just to make transactions observable
      return res
    grouped_transactions: ->
      incomes  = @all_trs.filter (tr) -> tr.subtype == 'i'
      expenses = @all_trs.filter (tr) -> tr.subtype == 'e'
      res =
        incomes:
          all: incomes
          sum: @$store.getters.transactions_sum(incomes)
          by_months: _.groupBy(incomes, (tr) -> hm_date.format(tr.date, 'YYYY-MM-01'))
        expenses:
          all: expenses
          sum: @$store.getters.transactions_sum(expenses)
          by_months: _.groupBy(expenses, (tr) -> hm_date.format(tr.date, 'YYYY-MM-01'))
      return res
    months_count: ->
      return 0 if @all_trs.length == 0
      start = hm_date.startOfMonth(_.minBy(@all_trs, 'date').date)
      end = hm_date.addDays hm_date.endOfMonth(_.maxBy(@all_trs, 'date').date), 1
      return hm_date.differenceInMonths(end, start)
    has_transactions: -> @all_trs.length > 0
  mounted: ->
    requestIdleCallback => @ready_to_draw = true
  methods:
    setCategories: (val) -> @categories = val
    setAccounts: (val) -> @accounts = val
    selectRange: (val) -> @selected_range = val
